// extracted by mini-css-extract-plugin
export default {"fr-view":"Multi_fr-view__RvAPy","action":"Multi_action__NQWpe"};